<template>
  <div>
    <Spinner ref="spinner" :block="true"/>
    <div class="container-fluid" v-if="occurrenceList">
      <OccurrenceListFilter v-model="filter" @input="emit" @submit="search"/>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <th>#</th>
            <th>Lojista</th>
            <th>Risco do lojista</th>
            <th>Aplicativo</th>
            <th>Data da ocorrência</th>
            <th>Risco da ocorrência</th>
            <th>Status</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="occurrence in occurrenceList.occurrences" :key="occurrence.id">
              <td>
                {{ occurrence.id }}
              </td>
              <td>
                  {{ occurrence.seller.personName }}
                  {{ getCompanyTradeName(occurrence) }}
                  <br />
                <small class="text-secondary">
                  {{ occurrence.seller.companyTaxDocument || occurrence.seller.personTaxDocument }}
                </small>
              </td>
              <td>
                <SellerRiskScore :fraudRisk="occurrence.seller.fraudRisk" />
              </td>
              <td>
                {{ getApplicationName(occurrence) }}
              </td>
              <td>
                {{ occurrence.createdAt | datetime }}<br>
                <small class="text-secondary">
                  {{ occurrence.suspiciousActivities.length }}
                  <span v-if="occurrence.suspiciousActivities.length > 1">atividades suspeitas</span>
                  <span v-else>atividade suspeita</span>
                </small>
              </td>
              <td>
                <OccurrenceSuspiciousScore :occurrence="occurrence" />
              </td>
              <td>
                <span v-if="!occurrence.completedAt">Pendente</span>
                <span v-if="occurrence.completedAt">Finalizada</span>
              </td>
              <td class="text-right">
                <router-link :to="{ name: 'occurrences-detail', params: { id: occurrence.id } }" class="btn btn-outline-info btn-block">
                  <i class="icon-magnifier"></i> &nbsp;
                  <span v-if="occurrence.completedAt">Visualizar</span>
                  <span v-else>Analisar</span>
                </router-link>
              </td>
            </tr>
            <tr v-if="occurrenceList.occurrences.length === 0">
              <td colspan="5">
                Nenhuma ocorrência encontrada.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="count > 0">
      <div class="d-flex justify-content-center">
        <paginator :count="count" :perPage="perPage" @exchange="turnPage"/>
      </div>
    </div>
  </div>
</template>

<script>
import OccurrenceListFilter from './OccurrenceListFilter'
import OccurrenceSuspiciousScore from './OccurrenceSuspiciousScore'
import SellerRiskScore from './SellerRiskScore'

export default {
  name: 'OccurrenceList',
  data () {
    return {
      filter: {
        index: 0,
        length: 10
      },
      occurrenceList: null,
      perPage: 10,
      count: 0
    }
  },
  async mounted () {
    await this.search()
  },
  methods: {
    async search () {
      this.$refs.spinner.show('Pesquisando ocorrências...')
      this.occurrenceList = await this.$api.occurrences.list(this.filter)
      this.count = this.occurrenceList.count
      this.$refs.spinner.hide()
    },
    emit (value) {
      this.filter = value
    },
    async turnPage (numberPage) {
      const end = numberPage * this.perPage
      const start = end - this.perPage
      this.filter.index = start
      this.filter.length = this.perPage
      await this.search()
    },
    getApplicationName (occurrence) {
      return occurrence.application != null ? occurrence.application : '-'
    },
    getCompanyTradeName (occurrence) {
      if (occurrence.seller.companyTradeName != null) {
        return `(${occurrence.seller.companyTradeName})`
      }
    }
  },
  components: {
    OccurrenceListFilter,
    OccurrenceSuspiciousScore,
    SellerRiskScore
  }
}
</script>
